import { Navigate } from "react-router-dom";
import { PrivateRouteWithLayout } from "../components/common";
import {
	LoginPage,
	LogsPage,
	GradesPage,
	AssessmentsPage,
	DashboardPage,
	AttendancePage,
	LecturesPage,
	TeachersPage,
	ClassesPage,
	StudentsPage,
	ParentsPage,
} from "../pages";
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from "../config";

export const routes = [
	// Public Routes
	{
		path: PUBLIC_ROUTES.LOGIN,
		element: <LoginPage />,
	},

	// Protected Routes
	{
		path: PRIVATE_ROUTES.DASHBOARD,
		element: (
			<PrivateRouteWithLayout>
				<DashboardPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.LOGS,
		element: (
			<PrivateRouteWithLayout>
				<LogsPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.GRADES,
		element: (
			<PrivateRouteWithLayout>
				<GradesPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.ASSESSMENTS,
		element: (
			<PrivateRouteWithLayout>
				<AssessmentsPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.ATTENDANCE,
		element: (
			<PrivateRouteWithLayout>
				<AttendancePage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.LECTURES,
		element: (
			<PrivateRouteWithLayout>
				<LecturesPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.TEACHERS,
		element: (
			<PrivateRouteWithLayout>
				<TeachersPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.CLASSES,
		element: (
			<PrivateRouteWithLayout>
				<ClassesPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.PARENTS,
		element: (
			<PrivateRouteWithLayout>
				<ParentsPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: PRIVATE_ROUTES.STUDENTS,
		element: (
			<PrivateRouteWithLayout>
				<StudentsPage />
			</PrivateRouteWithLayout>
		),
	},

	{
		path: "*",
		element: <Navigate to={PUBLIC_ROUTES.LOGIN} replace />,
	},
];
